module.exports = __webpack_public_path__ + "img/2.b576f944.jpg";